
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getCdpStatsSeries} from "../../ContractDataPoint/ContractDataPointClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeCdpStats} from "./cdpStatsSlice";
import {CdpStatsMenu} from "./CdpStatsMenu";


// main function
export default function SeriesCdpStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [seriesCdpStats, setSeriesCdpStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************


    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchSeriesCdpStats = () =>
        getCdpStatsSeries()

            .then(data => {
                console.log(data);
                setSeriesCdpStats(data);
            })
    useEffect(() => {
        fetchSeriesCdpStats();
    }, []);

    // ****************** END FETCH ****************************


    const renderSeriesCdpStats = seriesCdpStats => {
        if (seriesCdpStats.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectSeriesContractStatId,selectSeriesContractStatMcode, selectSeriesContractStatName, selectSeriesContractStatDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        // dispatchData(changeSeriesContractStat({id: selectSeriesContractStatId, mcode: selectSeriesContractStatMcode, name: selectSeriesContractStatName, description: selectSeriesContractStatDescription }));
    }

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (seriesCdpStats) => {

        console.log('Stats data from clicked row');
        console.log(seriesCdpStats);
        dispatchData(changeCdpStats({seriesId: seriesCdpStats.seriesId, seriesTitle: seriesCdpStats.seriesTitle,
            seasonId: null, seasonName: null, productId: null, episodeName: null, photoStartDate: null,
            gridDisplay: "SeasonFullScreen"}));
    };





    // ****************** BEGIN COLUMNS ****************************

    const columns = seriesCdpStats => [

        {    field: 'more',
            headerName: '',
            description: '',
            sortable: true,
            width: 60,
            hide: false,
            renderCell: (params) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <CdpStatsMenu row={params.row}  />
                </div>
            )
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'seriesTitle',
            headerName: 'Series Title',
            description: '',
            sortable: true,
            editable: true,
            hide: false,
            // editable: true,
            width: 300,
        },
        {
            field: 'seriesId',
            headerName: 'Series ID',
            description: '',
            sortable: false,
            editable: false,
            width: 100,


        },
        {
            field: 'participantsCount',
            headerName: 'Participants',
            width: 100,
            headerAlign: 'center',
            renderCell: (releaseMarketCdpStats) => {
                const count = releaseMarketCdpStats.row.participantsCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'residualsCount',
            headerName: 'Guilds',
            width: 100,
            headerAlign: 'center',
            renderCell: (releaseMarketCdpStats) => {
                const count = releaseMarketCdpStats.row.residualsCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'seasonCount',
            headerName: 'Seasons',
            headerAlign: 'center',
            width: 100,
            renderCell: (seriesCdpStats) => {
                const count = seriesCdpStats.row.seasonCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of seasons with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        //
        // {
        //     field: 'episodeCount',
        //     headerName: 'Episodes',
        //     headerAlign: 'center',
        //     width: 100,
        //     renderCell: (seriesCdpStats) => {
        //         const count = seriesCdpStats.row.episodeCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of episodes with contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },
        // {
        //     field: 'guildCount',
        //     headerName: 'Guilds',
        //     width: 100,
        //     headerAlign: 'center',
        //     renderCell: (seriesCdpStats) => {
        //         const count = seriesCdpStats.row.guildCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of guild contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },
        //
        // {
        //     field: 'guilds',
        //     headerName: 'Guilds',
        //     description: '',
        //     sortable: true,
        //     editable: false,
        //     hide: false,
        //     // editable: true,
        //     width: 300,
        // },
        {
            field: 'distinctOwedStatus',
            headerName: 'Owed Status',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 150,
        },
        {
            field: 'owedSumDisplay',
            headerName: 'Owed',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            // editable: true,
            width: 120,
        },
        {
            field: 'distinctPaymentStatus',
            headerName: 'Payment Status',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 150,
        },
        {
            field: 'paymentSumDisplay',
            headerName: 'Payment',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        {
            field: 'fringeSumDisplay',
            headerName: 'Fringe',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        {
            field: 'taxSumDisplay',
            headerName: 'Tax',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        {
            field: 'expenseSumDisplay',
            headerName: 'Expense',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        // {
        //     field: 'approvedCount',
        //     headerName: 'Approved',
        //     width: 100,
        //     headerAlign: 'center',
        //     renderCell: (seriesCdpStats) => {
        //         const count = seriesCdpStats.row.approvedCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of approved contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },
        // {
        //     field: 'unapprovedCount',
        //     headerName: 'Unapproved',
        //     width: 100,
        //     headerAlign: 'center',
        //     renderCell: (seriesCdpStats) => {
        //         const count = seriesCdpStats.row.unapprovedCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of unapproved contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         // backgroundColor: "rgb(30,144,255)",
        //                         backgroundColor: "warning.main",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },


    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Series Current Issuance Version Statistics</h3>
            </Box>
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                style={{cursor: 'pointer'}}
                aria-label={"SeriesCdpStats"}
                rows={seriesCdpStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchSeriesCdpStats)}
                onRowClick = {(seriesCdpStats)=>handleClickedRow(seriesCdpStats.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                // I just added back in rowKey from the AmigosCode example, which should define seriesContractStat and seriesContractStat.id
                // this is needed for identifying which seriesContractStat to delete or edit
                rowKey={seriesContractStat => seriesContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
            {/*<div>*/}
            {/*</div>*/}
        </div>
    );

    // ****************** END RETURN ****************************

}

